import React, { useEffect, useState } from "react";
import { auth } from "../firebaseConfig";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { analytics } from "../firebaseConfig";
import { logEvent } from "firebase/analytics";
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(()=>{
    logEvent(analytics, 'login_page');
  },[])

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg mt-8">
      <Helmet>
        <title>Log In | AI Contract Manager</title>
        <meta
          name="description"
          content="Securely log in to your AI Contract Manager account and access your organization’s contract documents, summaries, and analytics."
        />
        <link rel="canonical" href="https://aicontractmanager.com/login" />
        <meta property="og:title" content="Log In | AI Contract Manager" />
        <meta
          property="og:description"
          content="Access your secure dashboard and manage your organization's contracts with AI-powered tools built by Clairvoyant Inc."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://aicontractmanager.com/login" />
        <meta property="og:image" content="/preview-image.png" />
      </Helmet>

      <h2 className="text-2xl font-semibold mb-4 text-center text-blue-600 dark:text-blue-400">Login</h2>
      {error && <p className="text-red-500 text-center">{error}</p>}
      <form onSubmit={handleLogin} className="space-y-4">
        <input
          type="email" placeholder="Email" required
          className="w-full p-2 border dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
          value={email} onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password" placeholder="Password" required
          className="w-full p-2 border dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
          value={password} onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white p-2 rounded">
          Login
        </button>
      </form>
      <p className="text-center text-gray-700 dark:text-gray-300 mt-4">
        Don't have an account?
        <a href="/signup" className="text-blue-600 dark:text-blue-400 ml-1 hover:underline">Sign Up</a>
      </p>
    </div>
  );
};

export default Login;
